/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { AnyAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';
import UniversalTrackerModalService from '../model/UniversalTrackerModalService';
import { UniversalTrackerValuePlain } from '../types/surveyScope';

export type UniversalTrackerModalServiceUtrv = Pick<UniversalTrackerValuePlain,
  '_id' |
  'status' |
  'universalTrackerId' |
  'initiativeId' |
  'type' |
  'effectiveDate' |
  'value' |
  'valueData' |
  'assuranceStatus' |
  'compositeData' |
  'lastUpdated' |
  'valueType' |
  'stakeholders' |
  'aggregationCount' |
  'ledgerUniversalTrackerValue' |
  'period' |
  'disaggregation'
>;

export enum ShowAs {
  Chart = 'chart',
  Table = 'table'
}

interface UniversalTrackerModalCommon {
  loaded: boolean;
  open: boolean;
  modalService?: UniversalTrackerModalService | undefined;
  universalTrackerType?: string;
  universalTrackerId?: string;
  initiativeId?: string;
  loadedOverview: boolean;
  loadedHistory: boolean;
  loadingHistory: boolean;
  loadedActions: boolean;
  errored: boolean;
  errorMessage: string;
  history: UniversalTrackerModalServiceUtrv[];
  activeTabId?: ShowAs;
  hideProvenance: boolean;
  lastUpdated?: number;
  type?: any;
  alternativeCode?: string;
}

interface UniversalTrackerModalEmpty extends UniversalTrackerModalCommon {
  loaded: false;
}

interface UniversalTrackerModalLoaded extends UniversalTrackerModalCommon {
  loaded: true;
  modalService: UniversalTrackerModalService;
}

const universalTrackerModal = (

  state: (UniversalTrackerModalEmpty | UniversalTrackerModalLoaded) = {
    loaded: false,
    open: false,
    modalService: undefined,
    universalTrackerType: undefined,
    universalTrackerId: undefined,
    initiativeId: undefined,
    loadedOverview: false,
    loadedHistory: false,
    loadingHistory: false,
    loadedActions: false,
    errored: false,
    errorMessage: '',
    history: [],
    activeTabId: undefined,
    hideProvenance: false,
    alternativeCode: '',
  },
  action: AnyAction
): (UniversalTrackerModalEmpty | UniversalTrackerModalLoaded) => {

  switch (action.type) {

    case actionTypes.LOADING_UNIVERSALTRACKER_MODAL:
      return {
        ...state,
        open: true,
        modalService: undefined,
        universalTrackerType: action.universalTrackerType,
        universalTrackerId: action.universalTrackerId,
        loadedOverview: false,
        loadedHistory: false,
        loadingHistory: false,
        loadedActions: false,
        type: action.type,
        loaded: false, errored: false, lastUpdated: Date.now(),
        activeTabId: action.activeTabId,
        hideProvenance: Boolean(action.hideProvenance),
        alternativeCode: action.alternativeCode,
      };
    case actionTypes.ERROR_UNIVERSALTRACKER_MODAL:
      return { ...state, errored: true, lastUpdated: Date.now(), errorMessage: action.errorMessage }
    case actionTypes.NO_DATA_UNIVERSALTRACKER_MODAL:
      return { ...state, errored: false, lastUpdated: Date.now(), errorMessage: 'No Data' }
    case actionTypes.LOADED_INFO_UNIVERSALTRACKER_MODAL:
      return { ...state, modalService: action.modalService, loadedOverview: true, lastUpdated: Date.now() }
    case actionTypes.LOADING_HISTORY_UNIVERSALTRACKER_MODAL:
      return { ...state, loadingHistory: true, history: [] };
    case actionTypes.LOADED_HISTORY_UNIVERSALTRACKER_MODAL:
      return {
        ...state,
        modalService: action.modalService,
        loadedHistory: true,
        loadingHistory: false,
        initiativeId: action.initiativeId,
        lastUpdated: Date.now(),
        history: action.data,
      };
    case actionTypes.OPEN_UNIVERSALTRACKER_MODAL:
      return { ...state, open: true, activeTabId: action.activeTabId, alternativeCode: action.alternativeCode }
    case actionTypes.CLOSE_UNIVERSALTRACKER_MODAL:
      return {
        ...state,
        open: false,
        loaded: false,
        universalTrackerType: undefined,
        universalTrackerId: undefined,
        loadingHistory: false,
        loadedHistory: false,
        loadedActions: false,
        errored: false,
        hideProvenance: false,
        lastUpdated: Date.now(),
        history: []
      };
    default:
      return state;

  }

}

export default universalTrackerModal;
